module.exports = __webpack_public_path__ + "museosans700-webfont.0f633a896ce2a31fe262.woff2";


//////////////////
// WEBPACK FOOTER
// D:/api-fronted/css/fonts/museosans700-webfont.woff2
// module id = ../../../../../css/fonts/museosans700-webfont.woff2
// module chunks = styles